<template>
    <div class="addStaff">
        <div class="addStaff_main">
            <div class="addStaff_main_title">
                <i class="addStaff_main_icon_title"></i> 基础信息
            </div>
            <div class="addStaff_main_box">
                <div class="addStaff_main_avatars" style="flex:1">
                    <div style="text-align:center">
                        <el-upload class="avatar-uploader" :action="`${$uploadUrl}/erp/qiniu/uploadImg`"
                            :data="uploadData" :show-file-list="false" :on-success="handleAvatarSuccess"
                            :on-error="handleAvatarError" :headers="headers" :multiple="true"
                            :before-upload="beforeUpload" accept=".png, .jpg, .jpeg">
                            <img v-if="staffDate.photo" :src="'http://'+staffDate.photo" class="avatar" />
                            <div v-else>
                                <i class="el-icon-plus iconfont icon-icon_huxing icon_huxingtop"></i>
                            </div>
                        </el-upload>
                        <div class="avatar_box_msg">
                            <p>建议一寸照片</p>
                        </div>
                    </div>
                </div>
                <div class="addStaff_main_form" style="flex:4">
                    <div class="addStaff_main_form_item">
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                <span class="staffmsg_notice">*</span>员工编号：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.employeeNumber" placeholder="请输入员工编号"></el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                <span class="staffmsg_notice">*</span>姓
                                <span class="hidden">占位</span>名：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.name" placeholder="请输入姓名"></el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                <span class="staffmsg_notice">*</span>性
                                <span class="hidden">占位</span>别：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-select v-model="staffDate.sex" placeholder="请选择性别">
                                    <el-option v-for="item in sexList" :key="item.value" :label="item.valueDesc"
                                        :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                <span class="staffmsg_notice">*</span>电
                                <span class="hidden">占位</span>话：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.phone" placeholder="请输入电话"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="addStaff_main_form_item">
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                <span class="staffmsg_notice">*</span>身份证：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input @change="setbirthdate" v-model="staffDate.identityNumber"
                                    placeholder="请输入身份证"></el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                生
                                <span class="hidden">占位</span>日：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-date-picker v-model="staffDate.birthday" type="date" value-format="yyyy-MM-dd"
                                    placeholder="请选择生日"></el-date-picker>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                <span class="staffmsg_notice">*</span>入职时间：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-date-picker v-model="staffDate.entryDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择入职时间"></el-date-picker>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                证
                                <span class="hidden">占位</span>书：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-select v-model="staffDate.certificateType" placeholder="请选择证书">
                                    <el-option v-for="item in certificateTypeList" :key="item.value"
                                        :label="item.valueDesc" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="addStaff_main_form_item">
                        <div class="addStaff_main_form_item_ipt" @click="departpopshow=!departpopshow">
                            <div class="addStaff_main_form_item_ipt_label">
                                <span class="staffmsg_notice">*</span>所属部门 ：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content" style="padding-left:18px">
                                {{staffDate.departmentname}}
                                <div class="departpop" v-show="departpopshow">
                                    <el-tree :default-expand-all="true" :data="departmentList" :props="defaultProps"
                                        @node-click="handleNodeClick">
                                        <span class="custom-tree-node" slot-scope="{ node,data}">
                                            <div>
                                                <img class="tree-icon" v-if="data.labelName=='区'"
                                                    src="../../assets/icon/quyu.png" alt />
                                                <img class="tree-icon" v-if="data.labelName=='店'"
                                                    src="../../assets/icon/dian.png" alt />
                                                <img class="tree-icon" v-if="data.labelName=='组'"
                                                    src="../../assets/icon/zu.png" alt />
                                                <span>{{ data.name }}</span>
                                            </div>
                                        </span>
                                    </el-tree>
                                </div>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                <span class="staffmsg_notice">*</span>岗
                                <span class="hidden">占位</span>位：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-select v-model="staffDate.rolesId" placeholder="请选择岗位">
                                    <el-option v-for="item in roleList" :key="item.roleId" :label="item.name"
                                        :value="item.roleId"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                <span class="staffmsg_notice">*</span>状
                                <span class="hidden">占位</span>态：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-select v-model="staffDate.status" placeholder="请选择状态">
                                    <el-option v-for="item in employeestatusList" :key="item.value"
                                        :label="item.valueDesc" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                          <div class="addStaff_main_form_item_ipt_label">
                            <span class="staffmsg_notice">*</span>
                            员工等级：
                          </div>
                          <div class="addStaff_main_form_item_ipt_content">
                            <el-select v-model="staffDate.employeeLevel" placeholder="请选择员工等级">
                              <el-option v-for="item in employeeLevelList" :key="item.value"
                                         :label="item.valueDesc" :value="item.value"></el-option>
                            </el-select>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="addStaff_main_title">
                <i class="addStaff_main_icon_title"></i> 其他信息
            </div>
            <div class="addStaff_main_box">
                <div class="addStaff_main_form">
                    <div class="addStaff_main_form_item">
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                籍
                                <span class="hidden">占位</span>贯：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.nativePlace" placeholder="请输入籍贯"></el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                民
                                <span class="hidden">占位</span>族：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.nation" placeholder="请输入民族"></el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">政治面貌：</div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-select v-model="staffDate.politicalOutlook" placeholder="请选择政治面貌">
                                    <el-option v-for="item in politicalOutlookList" :key="item.value"
                                        :label="item.valueDesc" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">婚姻状况：</div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-select v-model="staffDate.maritalStatus" placeholder="请选择婚姻状况">
                                    <el-option v-for="item in marriageList" :key="item.value" :label="item.valueDesc"
                                        :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">最高学历：</div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-select v-model="staffDate.degree" placeholder="请选择最高学历">
                                    <el-option v-for="item in degreeList" :key="item.value" :label="item.valueDesc"
                                        :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="addStaff_main_form_item">
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">毕业年份：</div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.graduationYear" placeholder="请输入毕业年份"></el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">毕业院校：</div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.graduatedFrom" placeholder="请输入毕业院校"></el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                专
                                <span class="hidden">占位</span>业：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.major" placeholder="请输入专业"></el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">电子邮箱：</div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.email" placeholder="请输入电子邮箱"></el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">备用电话：</div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.standbyTelephone" placeholder="请输入备用电话"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="addStaff_main_form_item">
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">
                                Q
                                <span class="hidden">占位</span>Q ：
                            </div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.qq" placeholder="请输入QQ"></el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">紧急联系人：</div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.emergencyContact" placeholder="请输入紧急联系人"></el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt">
                            <div class="addStaff_main_form_item_ipt_label">紧急联系人电话：</div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.emergencyContactTelephone" placeholder="请输入紧急联系人电话">
                                </el-input>
                            </div>
                        </div>
                        <div class="addStaff_main_form_item_ipt" style="flex:2">
                            <div class="addStaff_main_form_item_ipt_label">联系地址：</div>
                            <div class="addStaff_main_form_item_ipt_content">
                                <el-input v-model="staffDate.currentResidence" placeholder="请输入联系地址"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="addStaff_main_form_item">
                        <div class="addStaff_main_form_item_ipt_label">
                            备
                            <span class="hidden">占位</span>注：
                        </div>
                        <div class="addStaff_main_form_item_ipt_content">
                            <el-input v-model="staffDate.remarks" placeholder="请输入备注"></el-input>
                        </div>
                    </div>
                    <div class="addStaff_main_form_item" style="height:131px">
                        <div class="addStaff_main_form_item_ipt_label">
                            附
                            <span class="hidden">占位</span>件：
                        </div>
                        <div class="upload_img">
                            <ul class="upload_img_type">
                                <li class="upload_img_icon" v-for="(item,index) in staffDate.enclosure" :key="index">
                                    <img :src="'http://'+item" alt />
                                </li>
                                <li class="upload_img_icon">
                                    <el-upload class="avatar-uploader" :action="`${$uploadUrl}/erp/qiniu/uploadImg`"
                                        :data="uploadData" :before-upload="beforeUpload" :show-file-list="false" :on-success="handlefujianSuccess"
                                        :on-error="handleAvatarError" :headers="headers" :multiple="true"
                                        accept=".png, .jpg, .jpeg">
                                        <div>
                                            <i class="el-icon-plus iconfont icon-icon_huxing icon_huxingbtom"></i>
                                            <span class="up_text">上传附件</span>
                                        </div>
                                    </el-upload>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-button type="primary" @click="saveStaff" style="float:right;margin:30px 0 0;background:#5e75e6">保存
        </el-button>
        <el-button type="primary" @click="cancel" style="float:right;margin:30px 40px;background:#999999;border:none">取消
        </el-button>
    </div>
</template>

<script>
import VueCookies from "vue-cookies";

import UploadImg from "@/components/common/uploadImg";

import {
    departmentFindAll,
    departmentFind,
    roleFind,
    employeestatus,
    employeeAdd,
    employeeUpdate,
    employeeDetail,
} from "@/api/manageCenter";
import { Loading } from "element-ui";
import { dicGet } from "@/api";
import {mapGetters} from "vuex";

export default {
    // name: "新增用户",
    name: "/StaffAdd",
  computed: {
    ...mapGetters({
      employeeLevelList: 'employeeLevel'
    }),
  },
    components: {
        UploadImg,
    },
    data() {
        let token = sessionStorage.getItem("accessToken") || "";
        return {
            staffId: "",
            uploadData: {},
            headers: {
                accessToken: token,
            },
            uploadImgVisible: false,
            departpopshow: false,
            staffDate: {
                name: "", //员工姓名
                departmentname: "请选择", //部门名称
                employeeNumber: "", //员工编号
                certificateType: "", //证书
                size: "", //图片大小
                sex: "", //性别
                phone: "", //员工电话
                email: "", //员工邮箱
                contactAddress: "", //联系地址
                entryDate: "", //入职时间
                storeId: "", //所在门店
                rolesId: "", //所属岗位
                status: "ENABLE", //员工状态
                departmentId: "", //部门编号
                photo: "", //员工头像
                identityNumber: "", //身份证
                identityFront: "", //身份证正面
                identityBack: "", //身份证反面
                birthday: "", //生日
                nativePlace: "", //籍贯
                nation: "", //民族
                politicalOutlook: "", //政治面貌
                maritalStatus: "", //婚姻状况
                degree: "", //最高学历
                graduationYear: "", //毕业年份
                graduatedFrom: "", //毕业院校
                major: "", //专业
                standbyTelephone: "", //备用电话
                emergencyContact: "", //紧急联系人
                emergencyContactTelephone: "", //紧急联系电话
                currentResidence: "", //现居地
                qq: "",
                remarks: "", //备注
                employeeLevel: "", // 员工等级
                enclosure: [], //附件
            },
            props: {
                label: "name",
                children: "child",
                value: "id",
            },
            departmentList: [], //部门列表
            roleList: [], //岗位列表
            certificateTypeList: [], //证书列表
            politicalOutlookList: [], //政治面貌列表
            marriageList: [], //婚姻状况列表
            degreeList: [], //最高学历列表
            employeestatusList: [], //员工状态列表
            sexList: [
                { value: "MALE", valueDesc: "男" },
                { value: "FEMALE", valueDesc: "女" },
            ], //性别列表
            defaultProps: {
                children: "child",
            },
        };
    },

    mounted() {
        this.getdepartmentFind();
        this.getroleFind();
        this.getcertificateTypeFind();
        this.getpoliticalOutlookFind();
        this.getmarriageFind();
        this.getdegreeFind();
        this.getemployeestatus();
    },

    methods: {
        beforeUpload(file){
            if (file.size / 1024 / 1024 > 8){}else {
                Loading.service({ background: 'transparent', text: '拼命上传中' });
            }
        },
        setbirthdate() {
            // 生成生日
            let idNumber = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            if (!idNumber.test(this.staffDate.identityNumber)) {
                this.$message({
                    type: "error",
                    message: "请输入正确的身份证号",
                });
                this.staffDate.birthday = "";
                return false;
            }
            this.staffDate.birthday =
                this.staffDate.identityNumber.substr(6, 4) +
                "-" +
                this.staffDate.identityNumber.substr(10, 2) +
                "-" +
                this.staffDate.identityNumber.substr(12, 2);
        },

        getdepartmentFind() {
            // 查询部门
            this.$post(departmentFind).then((res) => {
                if (res.success) {
                    this.departmentList = res.data;
                    //cosole.log(11111,this.departmentList )
                }
            });
        },
        getemployeestatus() {
            // 查询员工状态
            this.$post(employeestatus).then((res) => {
                if (res.success) {
                    this.employeestatusList = res.data;
                }
            });
        },

        getroleFind() {
            // 查询岗位
            let params = {
                status: "ENABLE",
            };
            this.$post(roleFind, params).then((res) => {
                if (res.success) {
                    this.roleList = res.data;
                }
            });
        },

        getcertificateTypeFind() {
            // 查询政治面貌
            let params = {
                code: "certificateType",
            };
            this.$post(dicGet, params).then((res) => {
                this.certificateTypeList = res.data;
            });
        },

        getpoliticalOutlookFind() {
            // 查询政治面貌
            let params = {
                code: "politicalOutlook",
            };
            this.$post(dicGet, params).then((res) => {
                this.politicalOutlookList = res.data;
            });
        },

        getmarriageFind() {
            // 查询婚姻状况
            let params = {
                code: "marriage",
            };
            this.$post(dicGet, params).then((res) => {
                this.marriageList = res.data;
            });
        },

        getdegreeFind() {
            // 查询最高学历
            let params = {
                code: "degree",
            };
            this.$post(dicGet, params).then((res) => {
                this.degreeList = res.data;
            });
        },

        cancel() {
            this.$router.push("staffManagement");
        },

        saveStaff() {
            // 新增员工
            let params = Object.assign({}, this.staffDate);
            if (params.enclosure) {
                params.enclosure = params.enclosure.join(",");
            }
            if (params.photo) {
                params.photo = this.staffDate.photo + "," + this.staffDate.size;
            }
            this.$post(employeeAdd, params).then((res) => {
                if (res.success) {
                    this.$router.push({ path: "/staffManagement" });
                    this.$store.commit("delete_tabs", "/StaffAdd");
                    this.$store.commit("delete_clude", "/StaffAdd");
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error",
                    });
                }
            });
        },

        handleAvatarError(err, file, fileList) {},
        handleAvatarSuccess(res, file) {
            if (res.code == 200) {
                this.staffDate.photo = res.uri;
                this.staffDate.size = res.size;
            } else {
                this.$message.error(res.msg);
            }
            Loading.service({ background: "transparent" }).close();
        },
        handlefujianSuccess(res, file) {
            if (res.code == 200) {
                this.staffDate.enclosure.push(res.uri);
            }else{
                this.$message.error(res.msg)
            }
            Loading.service({ background: "transparent" }).close();
        },

        handleNodeClick(node, data) {
            //cosole.log(node)
            this.staffDate.departmentId = node.id;
            this.staffDate.departmentname = node.name;
            this.departpopshow = false;
        },

        // 图片保存
        upLoadingBtn(data) {
            data.splice(data.length - 1, 1);
            if (!this.staffDate.enclosure) {
                var curimglist = [];
                data.map((item) => {
                    curimglist.push(item.uri);
                });
                this.staffDate.enclosure = [...curimglist];
            } else {
                var curimglist = [];
                data.map((item) => {
                    curimglist.push(item.uri);
                });
                this.staffDate.enclosure = this.staffDate.enclosure.concat(
                    ...curimglist
                );
                //cosole.log(5675756765,this.staffDate.enclosure)
            }
            this.uploadImgVisible = false;
        },
    },
};
</script>

<style lang="less">
.addStaff {
    height: 100%;
    margin: 10px;
    padding: 30px;
    background: #ffffff;
    &_main {
        width: 100%;
        border: 1px solid #e1e1e1;
        .staffmsg_notice {
            color: #f64e4e;
        }
        .hidden {
            visibility: hidden;
        }
        &_title {
            width: 100%;
            height: 40px;
            background: #f2f4ff;
            font-size: 16px;
            font-weight: bold;
            line-height: 40px;
            color: #333333;
            display: flex;
            align-items: center;
        }
        &_icon_title {
            margin: 0 13px;
            display: inline-block;
            width: 6px;
            height: 16px;
            background: rgba(94, 117, 230, 1);
            border-radius: 3px;
        }
        &_box {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        &_avatars {
            width: 302px;
            height: 120px;
            display: flex;
            padding: 8px;
            border-bottom: 1px solid #e1e1e1;
            border-right: 1px solid #e1e1e1;
            justify-content: center;
        }
        .avatar_box_msg {
            color: red;
            text-align: center;
        }

        &_form {
            flex: 1;
            &_item {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding-right: 20px;
                height: 40px;
                border-bottom: 1px solid #e1e1e1;
                &:nth-child(5) {
                    border-bottom: none;
                }
                .departpop {
                    width: 100%;
                    max-height: 260px;
                    overflow-y: auto;
                    position: absolute;
                    left: 0;
                    top: 41px;
                    z-index: 999;
                    border: 1px solid #eee;
                    .tree-item {
                        display: flex;
                        align-items: center;
                        img {
                            padding-right: 10px;
                        }
                    }
                }

                &_ipt {
                    flex: 1;
                    display: flex;
                    align-items: flex-start;
                    justify-content: center;
                    &_label {
                        min-width: 110px;
                        text-align: right;
                        font-size: 14px;
                        color: 14px;
                        line-height: 40px;
                    }
                    &_content {
                        flex: 1;
                        height: 40px;
                        font-size: 14px;
                        color: 14px;
                        line-height: 40px;
                        position: relative;
                        .el-input {
                            width: 100% !important;
                            .el-input {
                                width: 100%;
                            }
                            .el-input__inner {
                                width: 100%;
                                height: 39px !important;
                                line-height: 39px;
                                border: none;
                                padding-right: 3px;
                            }
                        }
                        .el-select {
                            width: 100% !important;
                            .el-input {
                                width: 100%;
                            }
                            .el-input__inner {
                                width: 100%;
                                height: 30px;
                                padding-right: 3px;
                            }
                        }
                        .el-date-editor {
                            width: 100% !important;
                            .el-input {
                                width: 100%;
                            }
                            .el-input__inner {
                                width: 100%;
                                height: 30px;
                                padding-right: 3px;
                            }
                        }
                    }
                }
                .upload_img {
                    // margin: 0 0 30px 0;
                    .upload_img_title {
                        font-size: 14px;
                        color: black;
                    }

                    .upload_img_type {
                        width: 710px;
                        margin-top: 8px;
                        display: flex;
                        align-items: top;

                        .upload_img_icon {
                            background: #f5f5f5;
                            border: 1px solid #ccc;
                            width: 70px;
                            min-width: 100px;
                            height: 100px;
                            border-radius: 4px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            color: #bbb;
                            margin-right: 20px;
                            img {
                                width: 100px;
                                height: 102px;
                            }

                            .icon-icon_shinei,
                            .icon-icon_huxing,
                            .icon-icon_VR,
                            .icon-icon_baomi {
                                font-size: 30px;
                            }

                            > span {
                                margin-top: 5px;
                                font-size: 14px;
                            }
                        }

                        .upload_img_text {
                            width: 100px;
                            min-width: 100px;
                            margin-left: 30px;
                            font-size: 14px;
                            line-height: 20px;
                            color: #bbb;
                        }
                    }
                }
            }
        }
    }
    .avatar_box {
        box-sizing: border-box;
        width: 70px;
        height: 100px;
        background: rgba(245, 245, 245, 1);
        border: 1px solid rgba(204, 204, 204, 1);
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 10px;
        left: 44px;
    }
    .delete,
    .save {
        width: 80px;
        height: 40px;
        border-radius: 4px;
        outline: none;
        border: none;
        color: #ffffff;
    }
    .delete {
        background: #999999;
        margin-right: 20px;
    }
    .save {
        background: #5e75e6;
        margin-right: 40px;
    }
    .up_text {
        position: absolute;
        left: 0;
        bottom: 5px;
        height: 30px;
        color: #999;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        width: 100%;
        background: #f5f5f5;
        opacity: 1;
    }
    .icon_huxingtop {
        font-size: 28px;
        color: #8c939d;
        width: 62px;
        height: 86px;
        line-height: 86px;
        text-align: center;
    }
    .icon_huxingbtom {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }
    .avatar {
        width: 62px !important;
        height: 86px !important;
        display: block;
    }
}
</style>
